<div class="form-inputs login-form">
    <form [formGroup]="loginForm" (ngSubmit)="clickOnLogin()">
        <mat-form-field class="col-12 mt-2">
            <mat-label>Email</mat-label>
            <input
                id="input-email-user"
                type="email"
                formControlName="email"
                matInput
                placeholder="Enter email"
                tabindex="1"
                autocomplete="username"
            />
            <mat-error>
                <app-field-error [field]="'email'" [messageList]="formErrors['email']" />
            </mat-error>
        </mat-form-field>
        @if (noSSOLogin) {
            <mat-form-field class="col-12">
                <mat-label>Password</mat-label>
                <input
                    id="input-password"
                    formControlName="password"
                    matInput
                    placeholder="Enter password"
                    [type]="hide ? 'password' : 'text'"
                    tabindex="2"
                    autocomplete="current-password"
                />
                <mat-icon matSuffix (click)="hide = !hide">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                <mat-error>
                    <app-field-error [field]="'password'" [messageList]="formErrors['password']" />
                </mat-error>
            </mat-form-field>

            <div class="d-flex justify-content-center">
                <button
                    id="forgot-password-btn"
                    mat-button
                    color="primary"
                    class="primary link mat-subtitle-2"
                    (click)="forgotTo()"
                    type="button"
                >
                    FORGOT PASSWORD
                </button>
            </div>
        }

        <button
            id="btn-submit"
            matButton="filled"
            type="submit"
            class="btn-login w-100 mt-2"
            color="primary"
            tabindex="3"
            [disabled]="loginForm.invalid"
        >
            {{ !noSSOLogin && !isLoading ? 'NEXT' : isLoading ? 'LOADING' : 'LOGIN' }}
            @if (isLoading) {
                <mat-icon iconPositionEnd>
                    <mat-spinner diameter="16" />
                </mat-icon>
            }
        </button>

        <a
            matButton="outlined"
            appMatStrokedButtonBorder
            color="primary"
            [href]="urlNewAccount | sanitize: 'url'"
            target="_blank"
            class="btn-account mt-3 p-0 w-100 border-2 overflow-hidden"
            tabindex="4"
            id="create-account-btn"
        >
            CREATE ACCOUNT
        </a>
    </form>
</div>
